import * as React from 'react';
import { Button } from "@/components/atoms/button";
import { Drawer, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from "@/components/atoms/drawer";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/atoms/form";
import { Input } from "@/components/atoms/input";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { updateCustomerDetails } from "@/services";
import type { Customer } from "@/types";

const myDetailsSchema = z.object({
  name: z.string(),
  phone: z.string(),
  mobile: z.string(),
  email: z.string().email()
});

type EditMyDetailsProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  customer: Customer;
}

export function EditMyDetails(props: EditMyDetailsProps) {

  const myDetailsForm = useForm<z.infer<typeof myDetailsSchema>>({
    resolver: zodResolver(myDetailsSchema),
    defaultValues: {
      name: props.customer?.name,
      phone: props.customer?.phone,
      mobile: props.customer?.mobile,
      email: props.customer?.email
    }
  });

  const onMyDetailsSubmit = (values: z.infer<typeof myDetailsSchema>) => {
    updateCustomerDetails(values as Customer).then(() => {
      props.onOpenChange(false);
    })
  }

  return(
    <Drawer
      direction="bottom"
      open={props.isOpen}
      onOpenChange={props.onOpenChange}
    >
      <DrawerContent>
        <div className="drawer-content overflow-y-auto">
          <DrawerHeader>
            <DrawerTitle>Edit My Details</DrawerTitle>
          </DrawerHeader>
          <div className="p-4">
            <Form {...myDetailsForm}>
              <form id="updateMyDetailsForm" onSubmit={myDetailsForm.handleSubmit(onMyDetailsSubmit)} className="space-y-6">
                <FormField
                  control={myDetailsForm.control}
                  name="name"
                  render={({field}) => (
                    <FormItem>
                      <FormLabel>Name</FormLabel>
                      <FormControl>
                        <Input placeholder="eg: John Smith" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>)}
                />
                <FormField
                  control={myDetailsForm.control}
                  name="phone"
                  render={({field}) => (
                    <FormItem>
                      <FormLabel>Phone</FormLabel>
                      <FormControl>
                        <Input type="tel" placeholder="eg: 02 95194764" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>)}
                />
                <FormField
                  control={myDetailsForm.control}
                  name="mobile"
                  render={({field}) => (
                    <FormItem>
                      <FormLabel>Mobile</FormLabel>
                      <FormControl>
                        <Input type="tel" placeholder="eg. 0411 333 444" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>)}
                />
                <FormField
                  control={myDetailsForm.control}
                  name="email"
                  render={({field}) => (
                    <FormItem>
                      <FormLabel>Email</FormLabel>
                      <FormControl>
                        <Input type="email" placeholder="eg: change_me@gmail.com" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>)}
                />
                <DrawerFooter>
                  <Button type="submit">Update My Details</Button>
                  <Button variant="secondary" onClick={() => props.onOpenChange(false)}>Cancel</Button>
                </DrawerFooter>
              </form>
            </Form>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
)
};